import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Avatar } from '@mui/material';
import { textAlign } from '@mui/system';
import './alumni-feedback.scss'
export default function Feedback() {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      };

      const Slide=({src,alt, Name, Batch, placement,feedback})=>{
        return(
            <div style={{display:'flex', alignItems:'center',flexDirection:'column', padding:"4%"}}>
            <Avatar alt={alt}
                    src={src}
                    imgProps={{style:{borderRadius:"65%"}}}
                    style={{width:120, height:120, border:'1px solid gray', padding:7}}
            ></Avatar>
            <p><b>{Name}</b></p>
            <p><i>{Batch}</i></p>
            <p>{placement}</p>
            <p>{feedback}</p>
            </div>
        )
      }


    return (
        
        <div>
            <h1 className='heading'>Alumni Feedback</h1>
           
            <div style={{justifyContent:"center", padding:"0 10% 10% 10%"}}>
            <Slider {...settings}>
            <Slide 
                alt="Ananya"
                src="https://bit-bangalore.edu.in/wp-content/uploads/2020/10/ananya.jpg"
                Name="Ananya Madhusudhan"
                Batch="Computer Science and Engineering - 2020"
                placement="One Direct - Full Stack Developer"
                feedback="When you are passionate about what you do, you would have reached halfway towards the goal. I always tried to enhance my skills by participating in technical events conducted in and out of the college. I concentrated on academics and also practiced coding on competitive coding platforms. Placement Center gave me the opportunity to enhance my skills and I was placed in OneDirect as Full Stack Developer with a package of Rs: 20.LPA. I express my profound gratitude for my teachers of BIT for helping me in achieving my goals."
            />
            <Slide 
                 alt="Ananya"
                src="https://bit-bangalore.edu.in/wp-content/uploads/2020/10/ananya.jpg"
                Name="Ananya Madhusudhan"
                Batch="Computer Science and Engineering - 2020"
                placement="One Direct - Full Stack Developer"
                feedback="When you are passionate about what you do, you would have reached halfway towards the goal. I always tried to enhance my skills by participating in technical events conducted in and out of the college. I concentrated on academics and also practiced coding on competitive coding platforms. Placement Center gave me the opportunity to enhance my skills and I was placed in OneDirect as Full Stack Developer with a package of Rs: 20.LPA. I express my profound gratitude for my teachers of BIT for helping me in achieving my goals."

            />
            <Slide />
            <Slide />
            <Slide />
            <Slide />
            <Slide />
                
            </Slider>
            </div>
           
        </div>
    )
}
// save images in folder and use its url and not from BIT site
// update all other slides
// change font style and color
// add timer
